import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export function CarrouselCampus({ images }) {
  const [idx, setIdx] = useState(0);
  const [direction, setDirection] = useState(1);

  if (!images || images.length === 0) return null;

  const go = (dir) => {
    setDirection(dir);
    setIdx((prev) => (prev + dir + images.length) % images.length);
  };

  return (
    <div className="relative w-full h-full overflow-hidden rounded-3xl bg-gray-100">
      <AnimatePresence initial={false} custom={direction}>
        <motion.img
          key={idx}
          custom={direction}
          src={images[idx]}
          alt={`Foto ${idx + 1}`}
          variants={{
            enter: (d) => ({ x: d > 0 ? '100%' : '-100%', opacity: 0 }),
            center: { x: 0, opacity: 1 },
            exit: (d) => ({ x: d > 0 ? '-100%' : '100%', opacity: 0 }),
          }}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.35, ease: 'easeInOut' }}
          className="absolute inset-0 w-full h-full object-cover"
          draggable={false}
        />
      </AnimatePresence>

      {images.length > 1 && (
        <>
          <button
            onClick={() => go(-1)}
            className="absolute left-3 top-1/2 -translate-y-1/2 z-10
                       w-9 h-9 rounded-full bg-black/40 hover:bg-black/70 text-white
                       flex items-center justify-center transition-colors"
            aria-label="Anterior"
          >
            <ChevronLeftIcon className="w-5 h-5" />
          </button>
          <button
            onClick={() => go(1)}
            className="absolute right-3 top-1/2 -translate-y-1/2 z-10
                       w-9 h-9 rounded-full bg-black/40 hover:bg-black/70 text-white
                       flex items-center justify-center transition-colors"
            aria-label="Siguiente"
          >
            <ChevronRightIcon className="w-5 h-5" />
          </button>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => { setDirection(i > idx ? 1 : -1); setIdx(i); }}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  i === idx ? 'w-6 bg-white' : 'w-2 bg-white/50'
                }`}
                aria-label={`Foto ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
